import { createFileRoute } from '@tanstack/react-router';

import { ReferralProgramPage } from '@apps/web/components/referrals/referral_rewards_page';
import { useOrganizationId } from '@apps/web/hooks/use_organization_id';

export const Route = createFileRoute('/_app/(main)/referrals')({
    head: () => ({
        meta: [
            {
                title: 'Referrals | Phoebe',
            },
        ],
    }),
    component: ReferralsRoute,
});

function ReferralsRoute() {
    const organizationId = useOrganizationId();
    if (!organizationId) {
        return null;
    }
    return <ReferralProgramPage organizationId={organizationId} />;
}
